<template>
  <div>
    <Head title="Create Market" />
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='Link' href="/markets">Markets</b-breadcrumb-item>
      <b-breadcrumb-item tag='Link' active>
        Create
      </b-breadcrumb-item>
    </b-breadcrumb>
    <card-component>
      <form @submit.prevent="store">
        <text-input v-model="form.city" :error="form.errors.city" class="mb-4" label="City" />
        <state-select :error="form.errors.state" class="mb-4" v-model="form.state"></state-select>
        <text-input v-model="form.postal_code" :error="form.errors.postal_code" class="mb-4" label="Zip Code" />

        <div v-if="vertical" class="p-6 m-6 bg-indigo-100 rounded">
          The vertical '{{ vertical.name }}' will automatically be attached to this market.
        </div>

        <div class="is-flex is-fullwidth is-justify-content-flex-end">
          <b-button :loading="form.processing" type="is-info" native-type="submit">Create Market</b-button>
        </div>
      </form>
    </card-component>


  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import StateSelect from "@/Shared/StateSelect";
import CardComponent from "@/Shared/CardComponent";

export default {
  components: {
    CardComponent,
    StateSelect,
    TextInput,
  },
  remember: 'form',
  props: {
    vertical: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        city: null,
        state: null,
        postal_code: null,
        vertical_id: this.vertical ? this.vertical.id : null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/markets')
    },
  },
}
</script>
